import React, { Component } from "react";
import PropTypes from "prop-types";
import { Link, StaticQuery, graphql, navigate } from "gatsby";
import "./menu.scss";
import { convertToSlug } from "../helpers/slugify";
import { returnColorCode } from "../helpers/color";
import AnchorLink from "react-anchor-link-smooth-scroll";
import { returnLanguageCode } from "../helpers/language";

class Menu extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showMenu: this.props.showMenu,
      openItem: this.props.currentChapterCodename,
      currentChapterCodename: this.props.currentChapterCodename,
    };

    this.toggleMenu = this.toggleMenu.bind(this);
    this.toggleMenuItem = this.toggleMenuItem.bind(this);

    if (typeof document !== "undefined") {
      if (!this.state.showMenu) {
        document.body.classList.remove("menu-open");
      } else {
        document.body.classList.add("menu-open");
      }
    }
  }

  toggleMenu(event) {
    // event.preventDefault();

    this.setState({
      showMenu: !this.state.showMenu,
    });

    if (typeof document !== "undefined") {
      if (this.state.showMenu) {
        document.body.classList.remove("menu-open");
      } else {
        document.body.classList.add("menu-open");
      }
    }
  }

  toggleMenuItem(event) {
    if (this.state.openItem !== event) {
      this.setState({
        openItem: event,
      });
    } else {
      this.setState({
        openItem: "",
      });
    }
  }

  render() {
    let listItems;
    let publicationUrl = "";
    let customNodes = [];
    Object.keys(this.props.data.allContentItem.edges).map((key, index) => {
      customNodes[this.props.data.allContentItem.edges[key].node.system.id] =
        this.props.data.allContentItem.edges[key].node;
    });

    this.props.items
      .filter(({ node }) => {
        return node.system.codename === this.props.publicationCodename;
      })
      .map(({ node }, index) => {
        // Name is defined
        listItems = node.elements.chapters
          .filter((node, index) => {
            const nodeLanguage = customNodes[node.system.id].kenticoElements.language.value.length
              ? returnLanguageCode(
                  customNodes[node.system.id].kenticoElements.language.value[0].codename
                )
              : "da";
            return this.props.language === nodeLanguage;
          })
          .map((node, index) => {
            publicationUrl =
              "/" + this.props.language + "/" + node.usedByContentItems[0].elements.url.value + "/";
            const name = node.elements.displayed_title.value
              ? node.elements.displayed_title.value
              : node.system.name;
            let subMenuItems;

            // Loop through subchapters
            if (node.elements.subchapters.length) {
              subMenuItems = node.elements.subchapters
                .filter((subchapter, index) => {
                  const nodeLanguage = customNodes[node.system.id].kenticoElements.language.value
                    .length
                    ? returnLanguageCode(
                        customNodes[node.system.id].kenticoElements.language.value[0].codename
                      )
                    : "da";
                  return this.props.language === nodeLanguage;
                })
                .map((subchapter, index) => {
                  const subChapterName = subchapter.elements.displayed_title.value
                    ? subchapter.elements.displayed_title.value
                    : subchapter.system.name;

                  let subSubMenuItems;
                  if (typeof document !== "undefined") {
                    const el = document.createElement("html");
                    el.innerHTML = subchapter.elements.content.value;
                    // const headings = el.querySelectorAll('h2, h3');
                    const headings = el.querySelectorAll("h2");
                    if (headings.length) {
                      const headingsArray = Array.from(headings);
                      subSubMenuItems = headingsArray.map((heading, index) => {
                        if (heading.tagName.toLowerCase() === "h2") {
                          return (
                            <li
                              key={index}
                              className={`menu__list-item ${
                                this.props.currentH2codename === convertToSlug(heading.innerHTML)
                                  ? "active"
                                  : ""
                              }`}
                            >
                              <AnchorLink
                                offset={() => 85}
                                href={`#${convertToSlug(heading.innerHTML)}`}
                                onClick={({ event }) => {
                                  this.toggleMenu(event);
                                }}
                              >
                                {heading.innerHTML}
                              </AnchorLink>
                            </li>
                          );
                        }
                      });
                    }
                  }
                  const nodeLanguage = customNodes[node.system.id].kenticoElements.language.value
                    .length
                    ? returnLanguageCode(
                        customNodes[node.system.id].kenticoElements.language.value[0].codename
                      )
                    : "da";
                  let url = "/" + nodeLanguage + "/";
                  if (typeof node.usedByContentItems[0] !== "undefined") {
                    url += node.usedByContentItems[0].elements.url.value + "/";
                  }
                  if (typeof subchapter.usedByContentItems[0] !== "undefined") {
                    url += subchapter.usedByContentItems[0].elements.url.value + "/";
                  }
                  if (typeof subchapter !== "undefined") {
                    url += subchapter.elements.url.value + "/";
                  }
                  return (
                    <li key={subchapter.system.codename} className="menu__list-item">
                      <Link to={url} activeClassName="active">
                        {subChapterName}
                      </Link>

                      <ul className="menu__list menu__list-subsubmenu" key={index} data-level="h3">
                        {subSubMenuItems}
                      </ul>
                    </li>
                  );
                });

              let chapterColor = returnColorCode(
                node.elements.semantic_colouring.value[0].codename
              );

              return (
                <li
                  key={convertToSlug(name)}
                  className={`menu__list-item menu__list-item--parent menu__list-item--${chapterColor} ${
                    this.state.openItem === convertToSlug(name) ? "open" : ""
                  }`}
                >
                  <button
                    onClick={(event) => {
                      this.toggleMenuItem(convertToSlug(name));
                    }}
                  >
                    {name}
                  </button>
                  {subMenuItems ? (
                    <ul className="menu__list menu__list-submenu" key={index} data-level="h2">
                      {subMenuItems}
                    </ul>
                  ) : (
                    ""
                  )}
                </li>
              );
            }
          });
      });
    return (
      <div className="menu-wrapper">
        {this.props.showButton ? (
          <button
            className={this.state.showMenu ? "menu__toggle menu__toggle--active" : "menu__toggle"}
            title="close"
            onClick={this.toggleMenu}
            expanded={this.state.showMenu ? "true" : "false"}
          >
            <span className="menu__toggle-lines"></span>
            <span className="menu__toggle-text">Menu</span>
          </button>
        ) : (
          ""
        )}
        <nav className={this.state.showMenu ? "menu menu--active" : "menu"}>
          <div className="menu__inner">
            <div className="menu__top">
              <h1>
                <Link to={publicationUrl}>{this.props.publicationTitle}</Link>
              </h1>
            </div>
            <div className="menu__bottom">
              <ul className="menu__list" role="menu">
                {listItems}
              </ul>
            </div>
          </div>
        </nav>
      </div>
    );
  }
}

export default ({
  publicationTitle,
  publicationCodename,
  showMenu,
  showButton,
  siteTitle,
  currentChapterCodename,
  currentH2codename,
  language,
}) => (
  <StaticQuery
    query={graphql`
      query {
        site {
          ...SiteInformationFragment
        }
        allKenticoCloudItemPublication {
          edges {
            node {
              ...AllPublicationsFragment
            }
          }
        }
        allContentItem {
          edges {
            node {
              system {
                id
                name
              }
              kenticoElements {
                language {
                  value {
                    codename
                  }
                }
              }
            }
          }
        }
      }
    `}
    render={(data) => (
      <Menu
        data={data}
        items={data.allKenticoCloudItemPublication.edges}
        publicationCodename={publicationCodename}
        publicationTitle={publicationTitle}
        showMenu={showMenu}
        showButton={showButton}
        siteTitle={data.site.siteMetadata.title}
        currentChapterCodename={currentChapterCodename}
        currentH2codename={currentH2codename}
        language={language}
      />
    )}
  ></StaticQuery>
);

Menu.propTypes = {
  items: PropTypes.array,
  publicationCodename: PropTypes.string,
  publicationTitle: PropTypes.string,
  showMenu: PropTypes.bool,
  showButton: PropTypes.bool,
  siteTitle: PropTypes.string,
  currentChapterCodename: PropTypes.string,
  currentH2codename: PropTypes.string,
  language: PropTypes.string,
  data: PropTypes.object,
};
